module.exports = new __parcel__URL__("1.fdfb8df6.webp").toString();